(function () {
    function setCookie(name, value, days = 7) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
    }
  
    function getCookie(name) {
      return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
      }, "");
    }
  
    function startTimer(timerEl) {
      const blockId = timerEl.dataset.blockId;
      const daysSetting = parseInt(timerEl.dataset.days, 10) || 0;
  
      const startDateCookieName = `countdown_start_${blockId}`;
      const targetDateCookieName = `countdown_target_${blockId}`;
  
      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
  
      const daysEl = timerEl.querySelector(`.js-timer-days-${blockId}`);
      const hoursEl = timerEl.querySelector(`.js-timer-hours-${blockId}`);
      const minutesEl = timerEl.querySelector(`.js-timer-minutes-${blockId}`);
      const secondsEl = timerEl.querySelector(`.js-timer-seconds-${blockId}`);
  
      function initializeTimer() {
        let startDate = getCookie(startDateCookieName);
        let targetDate = getCookie(targetDateCookieName);
  
        // No start date cookie -> this is the first time, set start date to today
        if (!startDate) {
          const now = new Date();
          // Set to start of day (00:00:00)
          now.setHours(0, 0, 0, 0);
          startDate = now.getTime();
          setCookie(startDateCookieName, startDate, 365); // Store for 1 year
          
          // Calculate target date from start date + days
          const newTarget = new Date(startDate + daysSetting * day);
          newTarget.setHours(23, 59, 59, 999);
          targetDate = newTarget.getTime();
          setCookie(targetDateCookieName, targetDate, 365); // Store for 1 year
        } else {
          startDate = parseInt(startDate, 10);
          // If target date doesn't exist but start date does, recalculate target
          if (!targetDate) {
            const newTarget = new Date(startDate + daysSetting * day);
            newTarget.setHours(23, 59, 59, 999);
            targetDate = newTarget.getTime();
            setCookie(targetDateCookieName, targetDate, 365);
          } else {
            targetDate = parseInt(targetDate, 10);
          }
        }
  
        return targetDate;
      }
  
      let intervalId = null;
      
      function runCountdown() {
        // Clear any existing interval
        if (intervalId) {
          clearInterval(intervalId);
        }
        
        let targetDate = initializeTimer();
  
        intervalId = setInterval(() => {
          const now = Date.now();
          const distance = targetDate - now;
  
          if (distance >= 0) {
            const daysLeft = Math.floor(distance / day);
            const hoursLeft = Math.floor((distance % day) / hour);
            const minutesLeft = Math.floor((distance % hour) / minute);
            const secondsLeft = Math.floor((distance % minute) / second);
  
            if (daysEl) daysEl.textContent = String(daysLeft).padStart(2, '0');
            if (hoursEl) hoursEl.textContent = String(hoursLeft).padStart(2, '0');
            if (minutesEl) minutesEl.textContent = String(minutesLeft).padStart(2, '0');
            if (secondsEl) secondsEl.textContent = String(secondsLeft).padStart(2, '0');
          } else {
            // Timer expired - restart the timer
            clearInterval(intervalId);
            intervalId = null;
            
            // Reset start date to now
            const now = new Date();
            now.setHours(0, 0, 0, 0);
            const newStartDate = now.getTime();
            setCookie(startDateCookieName, newStartDate, 365);
            
            // Calculate new target date from new start date + days
            const newTarget = new Date(newStartDate + daysSetting * day);
            newTarget.setHours(23, 59, 59, 999);
            const newTargetDate = newTarget.getTime();
            setCookie(targetDateCookieName, newTargetDate, 365);
            
            // Restart the countdown with new target date
            runCountdown();
          }
        }, second);
      }
  
      // Start the countdown
      runCountdown();
    }
  
    // Scroll to BFCM product module
    function scrollToBFCMModule(button) {
      const bfcmModule = document.querySelector('[data-bfcm-product-module]');
      if (bfcmModule) {
        const offsetTop = bfcmModule.offsetTop;
        window.scrollTo({
          top: offsetTop - 100, // 100px offset from top
          behavior: 'smooth'
        });
      }
    }

    // Initialize all timers on DOM load
    document.addEventListener("DOMContentLoaded", () => {
      const timers = document.querySelectorAll(".promotional-banner-timer");
      timers.forEach(startTimer);
      
      // Handle scroll to BFCM module buttons - attach with capture phase to ensure it runs first
      const scrollButtons = document.querySelectorAll('.promotional-banner [data-scroll-to-bfcm]');
      scrollButtons.forEach(button => {
        // Mark button to prevent global handler from attaching
        button.dataset.scrollOnly = 'true';
        
        // Attach scroll handler with capture phase (runs before other handlers)
        button.addEventListener('click', function(e) {
          // Only handle if this button has the scroll attribute
          if (!this.hasAttribute('data-scroll-to-bfcm')) {
            return;
          }
          
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          scrollToBFCMModule(this);
          return false;
        }, true); // Use capture phase to run before other handlers
      });
      
      // Initialize buy now buttons using global function (only for buttons without scroll attribute)
      if (window.initBuyNowButtons) {
        const buyNowButtons = document.querySelectorAll('.promotional-banner .buy_now:not([data-scroll-to-bfcm])');
        if (buyNowButtons.length > 0) {
          // Use the global function with a selector that excludes scroll buttons
          window.initBuyNowButtons('.promotional-banner .buy_now:not([data-scroll-to-bfcm])');
        }
      }
    });
  })();
  